export class EndPricingCardCommand {
	id: number;
	endDate?: string;
}
